/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description Components State Actions
 */

// Constants
import {
  GET_NEPHRO_MASTER_STATE,
  GET_NEPHRO_AUTH_STATE,
  GET_NEPHRO_INTEGRATOR_STATE,
  GET_NEPHRO_CALENDAR_STATE,
  GET_NEPHRO_MEDIA_STATE,
  GET_NEPHRO_COMMON_STATE
} from './constants';

/**
 * Call process to get MasterState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_MASTER_STATE
 */
export const getNephroMasterState = (callback) => ({
  type: GET_NEPHRO_MASTER_STATE,
  callback
});

/**
 * Call process to get AuthState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_AUTH_STATE
 */
export const getNephroAuthState = (callback) => ({
  type: GET_NEPHRO_AUTH_STATE,
  callback
});

/**
 * Call process to get IntegratorState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_INTEGRATOR_STATE
 */
export const getNephroIntegratorState = (callback) => ({
  type: GET_NEPHRO_INTEGRATOR_STATE,
  callback
});

/**
 * Call process to get CalendarState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_CALENDAR_STATE
 */
export const getNephroCalendarState = (callback) => ({
  type: GET_NEPHRO_CALENDAR_STATE,
  callback
});

/**
 * Call process to get MediaState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_MEDIA_STATE
 */
export const getNephroMediaState = (callback) => ({
  type: GET_NEPHRO_MEDIA_STATE,
  callback
});

/**
 * Call process to get CommonState State
 * @param { function } callback - Response callback
 * @returns { object } An action object with a type of GET_NEPHRO_COMMON_STATE
 */
export const getNephroCommonState = (callback) => ({
  type: GET_NEPHRO_COMMON_STATE,
  callback
});
